module.exports = __webpack_public_path__ + "img/ic_em.52c69d7f.svg";